<template>
  <v-layout row wrap justify-center py-4>
    <v-flex xs12 sm6>
      <v-card v-if="selectedSpot!=null">
        <v-img
          :src="selectedSpot['views'][0]"
          aspect-ratio="1.8"
          v-if="selectedSpot['views'].length > 0" />
        <v-card-text>{{selectedSpot['name']['written']}}</v-card-text>
        <v-list v-if="selectedSpot['place']['accurate_address'] === true">
          <v-list-tile v-if="selectedSpot['place']['accurate_address'] === true">
            <v-list-tile-content>
              <v-list-tile-title>住所</v-list-tile-title>
              <v-list-tile-sub-title>{{selectedSpot['place']['address']}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="selectedSpot['place']['phone']">
            <v-list-tile-content>
              <v-list-tile-title>電話番号</v-list-tile-title>
              <v-list-tile-sub-title>{{selectedSpot['place']['phone']}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="selectedSpot['place']['url']">
            <v-list-tile-content>
              <v-list-tile-title>URL</v-list-tile-title>
              <v-list-tile-sub-title><a target="_blank" :href="selectedSpot['place']['url']">{{selectedSpot['place']['url']}}</a></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <div id="_tweets" class="justify-center"></div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      selectedSpot: 'getSelectedSpotData'
    })
  },
  watch: {
    selectedSpot: function (newSpot, oldSpot) {
      this.render()
    }
  },
  methods: {
    render: function () {
      if (this.selectedSpot === null) {
        return
      }
      // 要素の全ての子を除去
      const element = document.getElementById('_tweets')
      while (element.firstChild) {
        element.removeChild(element.firstChild)
      }
      // tweet
      for (let i = 0; i < this.selectedSpot['tweets'].length; i++) {
        // eslint-disable-next-line
        twttr.widgets.createTweet(
          this.selectedSpot['tweets'][i],
          document.getElementById('_tweets'),
          {
            theme: 'dark'
          }
        )
        if (i >= 9) {
          break
        }
      }
    }
  },
  mounted: function () {
    this.render()
  },
  beforeDestroy: function () {
  }
}
</script>

<style>
#spotInfo {
  padding-top: 16px
}
</style>
